// Persistência dos itens de FAQ. A coleção `faq` vive no projeto heppi-production
// (mesma base lida pelo app mobile), então usamos o app Firebase secundário
// 'production' inicializado em main.js — NÃO o $firestore padrão (heppi-support-accc2).
//
// Cada documento (id auto-gerado) tem os campos:
//   question (string) · answer (string) · category (string) · order (number) · active (boolean)

import firebase from 'firebase/app'
import 'firebase/firestore'

const COLLECTION = 'faq'

function collection () {
  return firebase.app('production').firestore().collection(COLLECTION)
}

// Lista a coleção inteira ordenada por `order` asc (mesma ordenação do app mobile).
export function listFaq () {
  return collection().orderBy('order', 'asc').get()
    .then(snapshot => snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
}

export function createFaq (data) {
  return collection().add(normalize(data)).then(ref => ref.id)
}

export function updateFaq (id, data) {
  return collection().doc(id).update(normalize(data))
}

// Atualização parcial — usado pelo toggle rápido de `active` na listagem.
export function setFaqActive (id, active) {
  return collection().doc(id).update({ active: !!active })
}

export function removeFaq (id) {
  return collection().doc(id).delete()
}

// Garante os tipos corretos antes de gravar.
function normalize (data) {
  return {
    question: (data.question || '').trim(),
    answer: data.answer || '',
    category: (data.category || '').trim(),
    order: Number(data.order) || 0,
    active: !!data.active
  }
}
